export default __webpack_public_path__ + "9b16c1a01ed664d244c1d1a175d687d8.svg";